/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
import { getMe } from '../graph/graph.user';
import { IProvider, ProviderState } from '../providers/IProvider';
import { ProxyGraph } from '../ProxyGraph';
/**
 * Proxy Provider access token for Microsoft Graph APIs
 *
 * @export
 * @class ProxyProvider
 * @extends {IProvider}
 */
export class ProxyProvider extends IProvider {
    constructor(graphProxyUrl, getCustomHeaders = null) {
        super();
        this.graph = new ProxyGraph(graphProxyUrl, getCustomHeaders);
        getMe(this.graph).then(user => {
            if (user != null) {
                this.setState(ProviderState.SignedIn);
            }
            else {
                this.setState(ProviderState.SignedOut);
            }
        }, err => {
            this.setState(ProviderState.SignedOut);
        });
    }
    /**
     * Promise returning token
     *
     * @returns {Promise<string>}
     * @memberof ProxyProvider
     */
    getAccessToken() {
        return null;
    }
}
//# sourceMappingURL=ProxyProvider.js.map